import React from 'react';
import { useIntl } from 'react-intl';

import PaymentGatewayList from '../../../components/SiteAdmin/PaymentGatewayList/PaymentGatewayList';

import Loader from '../../../components/Common/Loader/Loader';

import getPaymentMethodsQuery from './getPaymentMethods.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import messages from '../../../locale/messages';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';

const PaymentGateway = () => {
  const { data: paymentMethods, loading } = useQueryResponse({
    query: getPaymentMethodsQuery,
    ssr: false,
    fetchPolicy: 'network-only'
  })
  const intl = useIntl()

  return (
    <Loader type={"page"} show={loading}>
      <h1 className='siteAdminPrimaryHeading'>{intl.formatMessage(messages.managePaymentGateWay)}</h1>
      <PaymentGatewayList getPaymentMethods={paymentMethods?.getAllPaymentMethods} />
    </Loader>
  );
}
export default PaymentGateway